import { Descriptions } from "antd";
import { EntityManager } from "../../components/entityManager";
import { enmControlType, enmPropertyType, IMetadata } from "../../components/entityManager/interfaces";
import { AndFilter, ComparisonFilter, enmConditionalOperators, IFilter } from "../../components/infrastructure/filtering";
import { Role } from "../role";
import { User } from "../user";
import { IUserRole, IUserRoleProps, IUserRoleStates } from "./interfaces";

export class UserRole extends EntityManager<IUserRole, IUserRoleProps, IUserRoleStates>{
    static initMetadata = (): IMetadata => {
        let metadata: IMetadata = {
            name: "UserRole",
            title: "نقش کاربر",
            Properties: [
                {
                    title: "کاربر",
                    dataIndex: "UserId",
                    propertyType: enmPropertyType.number,
                    controlType: enmControlType.lookup,
                    filterable: true,
                    width: 300,
                    rules: [{ required: true, message: 'کاربر اجباری است' }],
                    lookup: {
                        lookupComponent: User,
                        lookupProperty: "User",
                        lookupDisplayFields: ["UserName", "FullName"]
                    }
                },
                {
                    title: "نقش",
                    dataIndex: "RoleId",
                    propertyType: enmPropertyType.number,
                    controlType: enmControlType.lookup,
                    filterable: false,
                    width: 300,
                    rules: [{ required: true, message: 'نقش اجباری است' }],
                    lookup: {
                        lookupComponent: Role,
                        lookupProperty: "Role",
                        lookupDisplayFields: ["Description"]
                    }
                }]
        };
        return metadata;
    }

    onInitializing() {
        this.insertButtonTitle = () => 'افزودن';
        this.searchable = true;
        this.searchArea = {
            columnsPerRow: 2
        };
        this.onEntityAdded = (entity) => {
            if (this.props.params) {
                let role = this.props.params()?.role;
                if (role) {
                    entity.RoleId = role.Id;
                    entity.Role = role;
                    entity.ModifiedProperties.push("RoleId");
                }
                let user = this.props.params()?.user;
                if (user) {
                    entity.UserId = user.Id;
                    entity.User = user;
                    entity.ModifiedProperties.push("UserId");
                }
            }
            return true;
        };
        this.onDataFetching = (fetchingInfo) => {
            if (this.props.params) {
                let filters: IFilter[] = [];
                if (this.props.params()?.role?.Id)
                    filters.push(new ComparisonFilter("RoleId", enmConditionalOperators.Equal, this.props.params()?.role?.Id));
                if (this.props.params()?.user?.Id)
                    filters.push(new ComparisonFilter("UserId", enmConditionalOperators.Equal, this.props.params()?.user?.Id));
                if (filters.length) {
                    if (fetchingInfo.Filter)
                        fetchingInfo.Filter = fetchingInfo.Filter.And(filters);
                    else
                        fetchingInfo.Filter = new AndFilter(filters);
                }
            }
        };
        //this.renderingToolbar = () => {
        //    return (
        //        <>
        //            {!this.props.isChildComponent ?
        //                <>
        //                    <Col style={{ marginLeft: 10 }}>
        //                        <Button type="default" onClick={() => this.onRolesClick()}>نقش ها</Button>
        //                    </Col>
        //                    <Col style={{ marginLeft: 10 }}>
        //                        <Button type="default" onClick={() => this.onUsersClick()}>کاربر ها</Button>
        //                    </Col>
        //                </>
        //                : <></>}
        //        </>);
        //};
        this.extraHeaderNodes = () => {
            if (this.props.params) {
                const params = this.props.params();
                if (params.role?.Id)
                    return (
                        <Descriptions className="header-page">
                            <Descriptions.Item label="نام نقش">{params.role?.Description}</Descriptions.Item>
                            <Descriptions.Item label="عنوان نقش">{params.role?.Description}</Descriptions.Item>
                        </Descriptions>
                    );
                if (params.user?.Id)
                    return (
                        <Descriptions className="header-page">
                            <Descriptions.Item label="نام کاربری">{params.user?.UserName}</Descriptions.Item>
                            <Descriptions.Item label="نام و نام خانوادگی">{params.user?.FullName}</Descriptions.Item>
                        </Descriptions>
                    );
            }
        };
    }
}